module.exports = __webpack_public_path__ + "img/published.92eefb0d.svg";